// Options for project amounts
export const projectsAmountsOptions = [
  { id: 0, name: "من 0 الي 1000" },
  { id: 1, name: "من 1000 الي 10000" },
  { id: 2, name: "من 10000 الي 50000" },
  { id: 3, name: "اكثر من 5000" },
];

// Options for message donation types
export const messageDonateTypeOptions = [
  { value: 0, name: "الكل" },
  { value: 2, name: "متبرع سابق" },
  { value: 3, name: "غير متبرع" },
  { value: 4, name: "السلات المتروكة" },
  { value: 5, name: "الروابط الاعلانية" },
];
